import React from "react";
import { ArrowRight, Zap, ChevronDown } from "lucide-react";

const Hero = () => {
  return (
    <section data-testid="hero-section" className="hero-section">
      {/* Background */}
      <div className="hero-bg">
        <div className="hero-orb hero-orb-1 animate-float-orb-1" />
        <div className="hero-orb hero-orb-2 animate-float-orb-2" />
        <div className="hero-orb hero-orb-3 animate-float-orb-3" />
        <div className="hero-orb hero-orb-4 animate-float-orb-4" />
        <div className="hero-grid" />
        <div className="hero-gradient-line" />
        {/* Bottom gradient fade */}
        <div className="absolute bottom-0 left-0 right-0 h-48 bg-gradient-to-t from-[#050505] to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 pt-24 pb-16 w-full">
        <div className="max-w-4xl">
          {/* Badge */}
          <div
            data-testid="hero-badge"
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#00E599]/25 bg-[#00E599]/5 mb-8 animate-fade-in-up"
          >
            <span className="w-1.5 h-1.5 rounded-full bg-[#00E599] animate-badge-pulse" />
            <span className="text-xs font-semibold text-[#00E599] tracking-widest uppercase">
              Agentic AI Product Company
            </span>
          </div>

          {/* Headline */}
          <h1
            data-testid="hero-headline"
            className="animate-fade-in-up delay-100 opacity-0"
            style={{
              fontFamily: "Outfit, sans-serif",
              fontSize: "clamp(2.8rem, 7vw, 5.5rem)",
              fontWeight: 800,
              lineHeight: 1.05,
              letterSpacing: "-0.03em",
              color: "#ffffff",
              marginBottom: "1.5rem",
            }}
          >
            Building the Future
            <br />
            <span className="gradient-text-animated">with Agentic AI</span>
          </h1>

          {/* Subheadline */}
          <p
            data-testid="hero-subheadline"
            className="animate-fade-in-up delay-200 opacity-0 text-lg md:text-xl text-[#A1A1AA] max-w-2xl leading-relaxed mb-10"
            style={{ fontFamily: "Manrope, sans-serif" }}
          >
            We design and build AI Agents, Autonomous Workflows, and Vertical SaaS Platforms
            that automate operations, generate revenue, and transform industries.
          </p>

          {/* CTA Buttons */}
          <div
            data-testid="hero-cta-group"
            className="animate-fade-in-up delay-300 opacity-0 flex flex-col sm:flex-row gap-4 mb-16"
          >
            <a
              href="#contact"
              data-testid="hero-primary-cta"
              className="btn-primary-glow inline-flex items-center justify-center gap-2 font-semibold text-base rounded-full px-8 py-4"
            >
              Book a Strategy Call
              <ArrowRight size={17} />
            </a>
            <a
              href="#industries"
              data-testid="hero-secondary-cta"
              className="inline-flex items-center justify-center gap-2 font-semibold text-base text-white rounded-full px-8 py-4 border border-white/15 hover:bg-white/5 hover:border-white/25 transition-all duration-200"
            >
              <Zap size={15} className="text-[#00E599]" />
              Explore Products
            </a>
          </div>

          {/* Stats Strip */}
          <div
            data-testid="hero-stats"
            className="animate-fade-in-up delay-500 opacity-0 flex flex-wrap gap-8 md:gap-12"
          >
            {[
              { number: "6+", label: "Industry Verticals" },
              { number: "50+", label: "AI Agents Deployed" },
              { number: "10x", label: "Faster Operations" },
              { number: "24/7", label: "Autonomous Automation" },
            ].map((stat) => (
              <div key={stat.label} className="flex flex-col">
                <span
                  className="text-2xl md:text-3xl font-bold text-white"
                  style={{ fontFamily: "Outfit, sans-serif" }}
                >
                  {stat.number}
                </span>
                <span className="text-xs text-[#71717A] mt-0.5">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 opacity-40">
        <span className="text-xs text-[#71717A] tracking-widest uppercase">Scroll</span>
        <ChevronDown size={16} className="text-[#71717A] animate-scroll-bounce" />
      </div>
    </section>
  );
};

export default Hero;
